import { format } from 'date-fns-jalali';

/**
 * تبدیل تاریخ به فرمت فارسی
 * @param dateString تاریخ به فرمت ایزو یا تایم استمپ
 * @returns تاریخ فرمت شده
 */
export const formatDate = (dateString: string | number | Date): string => {
  try {
    const date = new Date(dateString);
    return format(date, 'yyyy/MM/dd HH:mm');
  } catch (error) {
    console.error('Error formatting date:', error);
    return String(dateString);
  }
}; 